export enum UserRoleEnum {
  user = 'user',
  covenant = 'covenant',
  covenant_collaborator = 'covenant_collaborator',
}

export enum StatusMessageEnum {
  Ok = 'ok',
  Minor = 'Minor',
  Major = 'Major',
  Maintenance = 'Maintenance',
}

export interface UserRoleRequest {
  user_role?: UserRoleEnum;
}

export interface GetResourcesRequest extends UserRoleRequest {
  //no extra parameters RN
}

export interface GetFrequentAskedQuestionsRequest extends UserRoleRequest {
  //no extra parameters RN
}

export interface GetStatusMessageRequest extends UserRoleRequest {
  //no extra parameters RN
}

export interface GetSolutionsRequest extends UserRoleRequest {
  problem_description?: string;
}

export enum AddIssueContactPreference {
  EMAIL = 'email',
  PHONE = 'phone',
}

export enum AddIssueTimePreference {
  MORNING = '9-13',
  AFTERNOON = '14-18'
}

export interface AddIssueRequest extends UserRoleRequest {
  captcha_check_info?: CaptchaCheckInfoRequest;
  identity_email?: string;
  identity_mobile_phone_number?: string | null;
  identity_activation_code?: string;
  identity_pan?: string;
  problem_description?: string;
  support_type?: string;
  contact_email?: string;
  contact_mobile_phone_number?: string | null;
  contact_preference_method?: AddIssueContactPreference;
  contact_preference_time?: AddIssueTimePreference;
}

export interface CaptchaCheckInfoRequest {
  captcha_token: string;
}

export interface UpdateIssueRequest {
  note?: string;
  //status: string;
}

export interface SupportItemResponse {
  id: number;
  title: string;
  description?: string;
  url?: string;
  status?: IssueStatusEnum;
  notes?: SupportItemNote[];
}

export interface SupportItemNote {
  name: string;
  text: string;
  role: 'Assistant' | 'User';
  date: Date;
}

export interface StatusMessageResponse {
  status: StatusMessageEnum;
  message: string;
}

export interface IssueResponse {
  id: number;
  support_phone: string;
}


export enum IssueStatusEnum {
  new = 'New',
  closed = 'Closed',
}

export interface UserDataResponse {
  role: UserRoleEnum;
  authenticated: boolean;
  card?: string;
}
